module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_07.9ef4e064.jpg";